module.exports = __webpack_public_path__ + "media/images/bg-shape-cream-6ccec7186edc99f97163dbbeb16cfba9.png";